import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useGetReturnHub } from '@dhl/mdp-api'
import { Box, Grid } from '@dhl-ui/components'

import { links } from '~/AppRoutes'
import { ReturnHubDetails } from '~/modules/returnhubsccc/components'
import { convertToReturnHub } from '~/modules/returnhubsccc/model'
import { BackButton } from '~/temp-ds-component/BackButton'

export const ReturnHubDetailsPage = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { t } = useTranslation()
  const { data: returnHub, isFetching } = useGetReturnHub(id || '', {
    query: { enabled: !!id, select: convertToReturnHub },
  })
  const onBack = () => navigate(links.returnHubsLink())

  if (isFetching || !returnHub) {
    return null
  }

  return (
    <>
      <Box mb={2}>
        <BackButton onClick={onBack}>{t('admin.returnHubPage.backButtonTitle')}</BackButton>
      </Box>
      <Box>
        <Grid size={{ sm: 6 }}>{returnHub && <ReturnHubDetails returnHub={returnHub} />}</Grid>
      </Box>
    </>
  )
}
